module.exports = __webpack_public_path__ + "media/images/home/card_non_gcse-74459771c3796688fa7d2c1fc15993c6.jpg";